/* SearchEmbedded.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _12 = "._11q76ota{background:var(--ds-surface)}";
const _11 = "._1pbyjbo9{z-index:100000}";
const _10 = "._4t3i1osq{height:100%}";
const _9 = "._1bsb1osq{width:100%}";
const _8 = "._1ltvidpf{left:0}";
const _7 = "._154iidpf{top:0}";
const _6 = "._kqsw1n9t{position:fixed}";
import { SearchEmbeddedEnterKeyEvent, SearchEmbeddedSuggestionClickEvent, SearchEmbeddedViewEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import React, { useRef, useState } from 'react';
import { ANALYTICS_ACTION_SUBJECT_ID } from '../constants';
import { SearchDropdownEmbedded, SearchDropdownOverlay } from '../SearchDropdown';
const _5 = "._kqswh2mm{position:relative}";
const _4 = "._zulp1b66{gap:var(--ds-space-050,4px)}";
const _3 = "._4cvr1y6m{align-items:flex-start}";
const _2 = "._2lx21bp4{flex-direction:column}";
const _ = "._1e0c1txw{display:flex}";
const SearchEmbeddedWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _2lx21bp4 _4cvr1y6m _zulp1b66 _kqswh2mm", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SearchEmbeddedWrapper.displayName = 'SearchEmbeddedWrapper';
}
const FullWidthSearchDropdown = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_6, _7, _8, _9, _10, _11, _12]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_kqsw1n9t _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _1pbyjbo9 _11q76ota", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  FullWidthSearchDropdown.displayName = 'FullWidthSearchDropdown';
}
// eslint-disable-next-line max-lines-per-function
export const SearchEmbedded = _ref3 => {
  let {
    searchInputRef,
    additionalQueryParams = {},
    searchPlaceholder
  } = _ref3;
  const [searchOverlayVisible, setSearchOverlayVisible] = useState(false);
  const searchDropdownOverlayref = useRef(null);
  const backButtonRef = useRef(null);
  const fireAnalyticsEvent = useAnalyticsEvents();
  const handleViewedAnalytics = _ref4 => {
    let {
      query,
      suggestionSource,
      count
    } = _ref4;
    fireAnalyticsEvent({
      eventType: SearchEmbeddedViewEvent,
      actionSubjectId: ANALYTICS_ACTION_SUBJECT_ID.SEARCH_EMBEDDED_VIEW,
      attributes: {
        query,
        suggestionSource,
        count
      }
    });
  };
  const handleSearchItemSelectionAnalytics = _ref5 => {
    let {
      query,
      position,
      popularity,
      suggestionSource,
      count
    } = _ref5;
    fireAnalyticsEvent({
      eventType: SearchEmbeddedSuggestionClickEvent,
      actionSubjectId: ANALYTICS_ACTION_SUBJECT_ID.SEARCH_EMBEDDED_ITEM_SELECTED,
      attributes: {
        query,
        position,
        popularity,
        suggestionSource,
        count
      }
    });
  };
  const handleEnterKeyPressAnalytics = _ref6 => {
    let {
      query,
      suggestionSource,
      count
    } = _ref6;
    fireAnalyticsEvent({
      eventType: SearchEmbeddedEnterKeyEvent,
      actionSubjectId: ANALYTICS_ACTION_SUBJECT_ID.SEARCH_EMBEDDED_ENTER_KEY_PRESSED,
      attributes: {
        query,
        position: -1,
        suggestionSource,
        count
      }
    });
  };
  const onBlur = e => {
    if (searchDropdownOverlayref.current && !searchDropdownOverlayref.current.contains(e.relatedTarget) && backButtonRef.current) {
      backButtonRef.current.focus();
    }
  };
  const searchInput = /*#__PURE__*/React.createElement(SearchDropdownOverlay, {
    onViewed: handleViewedAnalytics,
    closeOverlay: () => {
      setSearchOverlayVisible(false);
    },
    onSuggestionSelection: handleSearchItemSelectionAnalytics,
    onEnterKeyPress: handleEnterKeyPressAnalytics,
    backButtonRef: backButtonRef,
    additionalQueryParams: additionalQueryParams
  });
  if (searchOverlayVisible) {
    return /*#__PURE__*/React.createElement(FullWidthSearchDropdown, {
      ref: searchDropdownOverlayref,
      onBlur: onBlur
    }, searchInput);
  }
  return /*#__PURE__*/React.createElement(SearchEmbeddedWrapper, null, /*#__PURE__*/React.createElement(SearchDropdownEmbedded, {
    onViewed: handleViewedAnalytics,
    onSuggestionSelection: handleSearchItemSelectionAnalytics,
    onEnterKeyPress: handleEnterKeyPressAnalytics,
    searchInputRef: searchInputRef,
    onInputFocus: () => {
      setSearchOverlayVisible(true);
    },
    searchPlaceholder: searchPlaceholder,
    additionalQueryParams: additionalQueryParams
  }));
};